export default __webpack_public_path__ + "static/media/kick.d66d8a66.mp3";